import HoneybadgerVue from '@honeybadger-io/vue';
import Vue from 'vue';

export default ({ $config }) => {
  if ($config.honeybadgerApiKey) {
    Vue.use(HoneybadgerVue, {
      apiKey: $config.honeybadgerApiKey,
      environment: $config.environment,
      revision: $config.appRevision
    });
  }
};
